var _path, _path2, _line, _line2, _line3, _line4, _line5, _line6, _line7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNote(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a98e930c-8974-4b0a-b269-2a2ab89e97a3",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.1,10.8H11a2.69,2.69,0,0,0-2.7,2.7V24A2.69,2.69,0,0,0,11,26.7H22.9l7.3,6.5V26.7h1A2.69,2.69,0,0,0,33.9,24V13.5A2.78,2.78,0,0,0,31.1,10.8Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2,34.3a1.08,1.08,0,0,1-.7-.3l-7.1-6.3H11a3.8,3.8,0,0,1-3.8-3.8V13.5A3.8,3.8,0,0,1,11,9.7H31.1a3.78,3.78,0,0,1,3.8,3.7V24a3.85,3.85,0,0,1-3.7,3.8v5.5a.87.87,0,0,1-.6.9C30.5,34.3,30.4,34.3,30.2,34.3ZM11,11.8a1.75,1.75,0,0,0-1.7,1.7V24A1.75,1.75,0,0,0,11,25.7H22.9a.91.91,0,0,1,.7.3l5.6,5V26.8a1,1,0,0,1,1-1h1a1.75,1.75,0,0,0,1.7-1.7V13.5a1.77,1.77,0,0,0-1.8-1.7Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 11.74,
    y1: 15.39,
    x2: 16.42,
    y2: 15.39,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 24.01,
    y1: 15.39,
    x2: 29.35,
    y2: 15.39,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 11.74,
    y1: 17.97,
    x2: 14.78,
    y2: 17.97,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 16.42,
    y1: 17.97,
    x2: 30.14,
    y2: 17.97,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 11.74,
    y1: 20.46,
    x2: 18.87,
    y2: 20.46,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 24.45,
    y1: 20.46,
    x2: 28.71,
    y2: 20.46,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 16.42,
    y1: 23.6,
    x2: 22.69,
    y2: 23.6,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNote);
export default __webpack_public_path__ + "static/media/Note.829d0c84faf7d8de08ae7c167b1db7e9.svg";
export { ForwardRef as ReactComponent };